<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Macbinding Violation</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Macbinding Violation</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header" v-if="!_.isEmpty(list.data) && is_loading == false">
            <div class="btn-toolbar pull-right">
              <button class="btn btn-info" type="button" @click="showFilter = !show">
                <i class="fa fa-filter"></i>
                <span class="d-none d-sm-inline-flex">Filter</span>
              </button>
            </div>

            <div class="card-tools">
              <!-- <router-link :to="{ name: 'MacbindingViolationAdd' }" class="btn btn-success" v-if="actionCreate">
                <i class="fas fa-plus"></i> New
              </router-link> -->
              <button class="btn btn-outline" @click="exportFile()">
                <i class="icon-download"></i>
                <span class="d-none d-sm-inline-flex">Export</span>
              </button>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <!-- Audra Name -->
                  <div v-if="$organizationId == 1" class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="audraname"
                      >Audra Name</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.accountId"
                          :options="Object.keys(pre.audraName)"
                          :custom-label="(opt) => pre.audraName[opt]"
                          placeholder="Select Audra Name"
                          :searchable="true"
                          :multiple="false"
                          id="accountId"
                          v-bind:class="{
                            'has-error': errors.has('accountId'),
                          }"
                          name="accountId"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <!-- Device MAC -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="device_mac"
                      >Device MAC</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="device_mac"
                          name="device_mac"
                          v-model="filter.device_mac"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="Device MAC"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Violated MAC -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="violated_mac"
                      >Violated MAC</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="violated_mac"
                          name="violated_mac"
                          v-model="filter.violated_mac"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="Violated MAC"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Host IP -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="dev_ip">Host IP</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="dev_ip"
                          name="dev_ip"
                          v-model="filter.dev_ip"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="Host IP"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Violated IP -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="violated_ip"
                      >Violated IP</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="violated_ip"
                          name="violated_ip"
                          v-model="filter.violated_ip"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="Violated IP"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Time -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="created_at">Date</label>
                    <div class="col-md-9">
                      <date-picker
                        autocomplete="off"
                        id="created_at"
                        name="created_at"
                        v-model="filter.created_at"
                        placeholder="Time"
                        valueType="format"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row justify-content-end">
                    <div class="col-md-9">
                      <button type="submit" class="btn btn-common mr-3">
                        <i class="icon-search"></i> Search
                      </button>
                      <button type="reset" class="btn btn-outline" @click="resetFilter()">
                        <i class="icon-refresh"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th v-if="$organizationId == 1">Audra</th>
                      <th>Host MAC</th>
                      <th>Violated MAC</th>
                      <th>Host IP</th>
                      <th>Violated IP</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(val, index) in list.data">
                      <td v-if="$organizationId == 1">
                        {{ pre.audraName[val.accountId] }}
                      </td>
                      <td>{{ val.device_mac.toUpperCase() }}</td>
                      <td>{{ val.violated_mac.toUpperCase() }}</td>
                      <td>{{ val.dev_ip }}</td>
                      <td>{{ val.violated_ip }}</td>
                      <td>{{ val.created_att }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>

            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { Notification } from "element-ui";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
// const fileDownload = require("js-file-download");
import { fileDownload } from "@/utils/CommonUtils";

export default {
  name: "MacbindingViolation",
  metaInfo: {
    title: "Macbinding Violation | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: false,
    actionView: false,
    actionEdit: false,
    actionDelete: false,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {
      audraName: [],
    },
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/macbinding_violations";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // await CommonAPI.getCustomPermission(
      //   "/get-custom-permission-infos?path=api/macbinding_violations"
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data;
      //   }
      // });

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data["create_id_condition"],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   );
      // }

      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });
      this.is_loading = false;
    },
    async getFilterData() {
      this.list.current_page = 1;
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    reload: function () {
      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    exportFile: function () {
      this.is_loading = true;
      axios
        .get("/macbinding-violations-export", {
          params: { userAccountId: LocalStorage.get("accountId") },
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "macbinding_violations.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
          Notification.success({
            title: "Export Completed",
            message: "Export operation completed successfully",
            type: "success",
          });
        });
    },

    processTime(dateString) {
      return moment.parseZone(dateString).format("DD-MM-YYYY, h:mm:ss a");
    },
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
